import { Component, OnInit } from "@angular/core";
import { ServerService } from "../../../shared/services/server.service";
import { ISpot } from "../../../shared/models/models";
import { ActivatedRoute } from "@angular/router";
import { FlatsModalComponent } from "../../flats-modal/flats-modal.component";
import { EventService } from "../../../shared/services/event.service";

@Component({
  selector: "app-object-realization",
  templateUrl: "./object-realization.component.html",
  styleUrls: ["./object-realization.component.scss"],
})

export class ObjectRealizationComponent implements OnInit {

  loading: boolean = false;
  spots: ISpot[] = [];
  selectedSpotIndex: number;
  spotColors = [];

  constructor(private route: ActivatedRoute, private serverService: ServerService, private eventService: EventService) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.route.parent.params.subscribe(params => {
      this.serverService.getObject(params.id).then(res => {
        if (res && typeof (res.spots) !== 'undefined' && res.spots !== null) {
          this.loading = false;
          this.spots = this.updateSpots(res.spots);
          this.spotColors = this.getColorOfSpots(this.spots);
          this.serverService.getSpotActDoc(res.spots.id).then(r1 => {

           this.spots.forEach(r2 => {
             r2.docs = r1.filter(r3 => r3.buildingID === r2.id);
           });
           
          });
        }
      });
    });
   
  }

  updateSpots(rows: ISpot[]) {
    rows.map(r => {
      r.isOpen = false;
    });
    return rows;
  }

  selectedSpotId: number;
  openSpot(index: number) {
    this.selectedSpotId = this.spots[index].id;
    if (this.selectedSpotIndex === index) {
      this.spots[index].isOpen = !this.spots[index].isOpen;
    } else {
      this.spots.map(r => { r.isOpen = false; });
      this.spots[index].isOpen = true;
      this.selectedSpotIndex = index;
    }
  }

  getColorOfSpots(rows: ISpot[]) {
    let arr = [];
    rows.map(r => {
      if (r.realisationPercent > 0 && r.realisationPercent < 100) { arr.push('violet'); }
      if (r.realisationPercent === 0) { arr.push(''); }
      if (r.realisationPercent === 100) { arr.push('green'); }
    });
    return arr;
  }

}
